import { render, staticRenderFns } from "./SetOffPayRateModal.vue?vue&type=template&id=19cb3538&"
import script from "./SetOffPayRateModal.vue?vue&type=script&lang=js&"
export * from "./SetOffPayRateModal.vue?vue&type=script&lang=js&"
import style0 from "./SetOffPayRateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports